var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('basic-heading',{attrs:{"title":'Result Exports'}}),_c('result-export-table',{attrs:{"collection":_vm.export_collection,"isListPage":true},on:{"rowClick":_vm.handleRowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }